import api    from '../../../../configs/api'
import Form   from '../../../../display/forms/FormElements'
import Person from '../../../../things/Person'

import getExistingSuggestions from '../../../../things/getExistingSuggestions'

const elements =
[
    {
        type  : Form.SEARCH_SELECTOR ,
        path  : api.people.url ,
        clazz : Person,
        init  :
        {
            id        : 'value',
            key       : 'value',
            label     : 'Fondateur',
            autoFocus : false,
            fullWidth : true,
            margin    : 'normal',
            required  : true,
            type      : 'search',
            variant   : 'outlined'
        },
        disabledSuggestions : getExistingSuggestions({ member:'founder' , clazz:Person }) ,
        selector : { i18n :
        {
            empty       : 'Aucune personne disponible.' ,
            title       : 'Sélectionner une personne',
            description : 'Veuillez sélectionner une personne ci-dessous.' ,
        }}
    }
];

const founder =
{
    add :
    {
        elements,
        agree       : 'Ajouter' ,
        disagree    : 'Annuler' ,
        description : 'Veuillez sélectionner une personne en cliquant ci-dessous.' ,
        fail        : 'Veuillez corriger les erreurs ci-dessous!' ,
        loading     : 'Chargement en  cours...' ,
        success     : 'Ajout du nouveau fondateur réussi!' ,
        title       : 'Ajouter un fondateur'
    },
    remove :
    {
        agree       : 'Supprimer' ,
        description : 'Souhaitez-vous supprimer ce fondateur:' ,
        disagree    : 'Annuler' ,
        loading     : 'Suppression en cours...' ,
        title       : 'Supprimer le fondateur ?'
    },
    title : 'Fondateurs' ,
    tooltips :
    {
        add    : "Ajouter" ,
        edit   : "Éditer" ,
        remove : "Supprimer"
    }
};

export default founder ;